import React from "react";
import { Routes, Route } from "react-router-dom";
import Footer from "./components/Footer";
import LandingPage from "./pages/landing-page/LandingPage";
import AdminContainer from "./pages/admin/admin-container/AdminContainer";
import Error404 from "./pages/errors/Error404";
import Error500 from "./pages/errors/Error500";
import "./App.css";
import TeacherContainer from "./pages/teacher/teacher-container/TeacherContainer";
import StudentContainer from "./pages/student/student-container/StudentContainer";

function App() {
  return (
    <div className="flex flex-col min-h-screen">
      <div className="flex-grow">
        <Routes>
          <Route path="/" element={<LandingPage tabTitle="Project Hub" />} />
          <Route
            path="/admin/*"
            element={<AdminContainer tabTitle="Project Hub" />}
          />
          <Route
            path="/teacher/*"
            element={<TeacherContainer tabTitle="Project Hub" />}
          />
          <Route
            path="/student/*"
            element={<StudentContainer tabTitle="Project Hub" />}
          />
          <Route
            path="/500"
            element={<Error500 tabTitle="500 Server Error" />}
          />
          <Route
            path="*"
            element={<Error404 tabTitle="404 Page Not Found" />}
          />
        </Routes>
      </div>
      <Footer />
    </div>
  );
}

export default App;
